/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Other_1Inputs */



/**
* | output |
* | --- |
* | "Open your browser's site settings, usually through the icon to the left of the web address." |
*
* @param {Practice_Session_Mic_Blocked_Other_1Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_other_1 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Other_1Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Other_1Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Open de website-instellingen van je browser, meestal via het icoon links van het webadres.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrez les paramètres du site dans votre navigateur, en général via l'icône à gauche de l'adresse web.")
	return /** @type {LocalizedString} */ ("Open your browser's site settings, usually through the icon to the left of the web address.")
});